import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import TableSelector from "./TableSelector";
import {ComponentContext} from "../../contexts";
import FieldsEditor from "./FieldsEditor";
import TypeSelector from "./TypeSelector";
import FormField from "../Helpers/FormField";
import {checkbox, custom, input} from "../../utils/linker";
import Popup from "../Helpers/Popup";
import FieldSettings from "./FieldSettings";
import CategorySettings from "./CategorySettings";
import CategoryAccess from "./CategoryAccess";
import Taglist from "../Helpers/Taglist/Taglist";
import CategoryIndexes from "./CategoryIndexes";
import ExportImport from "./ExportImport";

function CategoryEditor(props) {
  const store = useLocalObservable(() => ({
    popup_settings:false,
    popup_access:false,
    popup_indexes:false,
    popup_connections:false,
    tags:[],
  }));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const isFieldsEnabled=()=>{
    return compContext.cur_type_view === "elements" || (compContext.cur_type_view === "sections" && compContext.curView().enabled === 1);
  }

  const renderFieldsEditor=()=>{
    if(isFieldsEnabled()) {
      return (
        <div className="smartHPadding">
          <div className="fs18 bold pbottom10">Таблицы</div>
          <div className="bg-w1">
            <TableSelector />
          </div>

          <FieldsEditor />

          <div className="ptop20">
            <span className="btn1 mright20" onClick={()=>{ compContext.addField(); }}><span>Добавить поле</span></span>
            <span className="btn2 mright20" onClick={()=>{
              compContext.addTable();
            }} ><span>Добавить таблицу</span></span>
            <span className="btn2" onClick={()=>{
              runInAction(()=>{ store.popup_indexes=true; });
            }} ><span>Индексы</span></span>
          </div>
        </div>
      )
    };
    return null;
  };
  const getModelClassName=()=>{
    if(compContext.curView().code) {
      let ex=compContext.curView().code.split("_");
      ex=ex.filter((item)=>{ return item; });
      ex=ex.map((item)=>{
        return item.charAt(0).toUpperCase() + item.slice(1);
      });
      return ex.join("");
    }
    return "";
  };

  const name=compContext.struct.elements.name || compContext.struct.elements.code || "";

  return (
    <div>
      <div className="smartHPadding bg-w1">
        <div className="up12 margin">
          <div className="cell s-auto">
            <h1>{name || "Добавление категории"}</h1>
          </div>
          <div className="cell s-shrink">
            <div className="cb"></div>
          </div>
        </div>
        <div className="up12 margin">
          <div className="cell s-auto">
            <TypeSelector />
          </div>
          <div className="cell s-shrink s-middle">
            <ExportImport />
          </div>
        </div>

      </div>

      <div className="ptop20">

        {compContext.cur_type_view === "sections"?(
          <div className="smartHPadding pbottom20">
            <FormField title="Включить секции" input_id="chk_enable_sections" type="checkbox">
              <input id="chk_enable_sections" type="checkbox" {...checkbox(compContext.curView(), "enabled")} />
            </FormField>
          </div>
        ):null}

        {isFieldsEnabled()?(
          <div className="smartHPadding">
            <div className="up12 margin pbottom20">
              <div onClick={()=>{ runInAction(()=>{ store.popup_settings=true; }); }} className="cell s-shrink pc1 pointer">Настройки категории</div>
              <div onClick={()=>{ runInAction(()=>{ store.popup_connections=true; }); }} className="cell s-shrink pc1 pointer">Связь со структурой</div>
              <div onClick={()=>{ runInAction(()=>{ store.popup_access=true; }); }} className="cell s-shrink pc1 pointer">Права доступа</div>
            </div>

              <div className="up12 margin pbottom20">
                <div className="cell s-3">
                  <FormField title="Название">
                    <input type="text" {...input(compContext.curView(), "name")} className="w100" readOnly={compContext.cur_type_view === "sections"} />
                  </FormField>
                </div>
                <div className="cell s-3">
                  <FormField title="Код">
                    <input type="text" {...input(compContext.curView(), "code")} className="w100" readOnly={compContext.cur_type_view === "sections" || compContext.curView().locked} />
                  </FormField>
                </div>
                {getModelClassName()?(
                  <div className="cell s-6">
                    <div className="up12 margin">
                      <div className="cell s-4">
                        <FormField title="Модель">
                          <input type="text" readOnly={true} value={getModelClassName()} className="bg-w2 w100" style={{background:'#F2F2F2'}}/>
                        </FormField>
                      </div>
                      <div className="cell s-4">
                        <FormField title="Список">
                          <input type="text" readOnly={true} value={getModelClassName()+"List"} className="bg-w2 w100" style={{background:'#F2F2F2'}}/>
                        </FormField>
                      </div>
                      <div className="cell s-4">
                        <FormField title="Блендер">
                          <input type="text" readOnly={true} value={getModelClassName()+"Blender"} className="bg-w2 w100" style={{background:'#F2F2F2'}}/>
                        </FormField>
                      </div>
                    </div>
                  </div>
                ):null}
              </div>

          </div>
        ):null}

        {renderFieldsEditor()}

        <Popup disablePaddings={true} showed={store.popup_settings} onHide={()=>{ runInAction(()=>{ store.popup_settings=false; }); }}>
          <div style={{width: 420}} className="pr ">
            <div className="padd20">
              <div className="up12 splice">
                <div className="cell s-auto fs18 bold pbottom20">Настройки категории</div>
                <div className="cell s-shrink">
                  <span className="mdi mdi-close fs24 pointer" onClick={()=>{ runInAction(()=>{ store.popup_settings=false; }); }}></span>
                </div>
              </div>
              <CategorySettings />
            </div>
          </div>
        </Popup>

        <Popup disablePaddings={true} showed={store.popup_indexes} onHide={()=>{ runInAction(()=>{ store.popup_indexes=false; }); }}>
          <div style={{width: 420}} className="pr ">
            <div className="padd20">
              <div className="up12 splice">
                <div className="cell s-auto fs18 bold pbottom20">Индексы</div>
                <div className="cell s-shrink">
                  <span className="mdi mdi-close fs24 pointer" onClick={()=>{ runInAction(()=>{ store.popup_indexes=false; }); }}></span>
                </div>
              </div>
              <CategoryIndexes />
            </div>
          </div>
        </Popup>

        <Popup disablePaddings={true} showed={store.popup_access} onHide={()=>{ runInAction(()=>{ store.popup_access=false; }); }}>
          <div style={{width: 420}} className="pr ">
            <div className="padd20">
              <div className="up12 splice">
                <div className="cell s-auto fs18 bold pbottom20">Настройки прав доступа</div>
                <div className="cell s-shrink">
                  <span className="mdi mdi-close fs24 pointer" onClick={()=>{ runInAction(()=>{ store.popup_access=false; }); }}></span>
                </div>
              </div>
              <CategoryAccess />
            </div>
          </div>
        </Popup>

        <div className="dn">
          <textarea name={compContext.options.inputName} value={JSON.stringify(toJS(compContext.struct))}  readOnly={true} style={{width:500, height:300}} />
        </div>
      </div>
    </div>
  )
};

CategoryEditor.defaultProps = {};

CategoryEditor.propTypes = {}

export default observer(CategoryEditor);
